export const unauthorizedContentRedirectKey = 'unauthorized-content-page';
